(function($){
    'use strict';

    const $body = $('body');

    $('.ce_rsce_section_link').each(function() {
        const $sectionLink = $(this);
        const $parentArticle = $sectionLink.closest('.mod_article');
        const $allArticles = $('.mod_article');

        $sectionLink.find('button').on(Utils.clickEvent, function() {
            $allArticles.each(function(i, e) {
                if (e === $parentArticle.get(0)) {
                    const $nextArticle = $allArticles.eq(i+1);

                    if (0 === $nextArticle.length) {
                        return false;
                    }
                    
                    $('html,body').animate({
                        scrollTop: $nextArticle.offset().top - ($body.hasClass('index') ? 0 : 50)
                    }, 400);

                    return false;
                }
            });
        });
    });
})(jQuery);
